import * as React from "react";

import AboutPage from "../landing_pages/AboutPage";
import ContactPage from "../landing_pages/ContactPage";
import ErrorPage from "../ErrorPage";
import LifeAtVersePage from "../landing_pages/LifeAtVersePage";
import Login from "../Login";
import LoginPage from "../LoginPage";
import NewHomePage from "../landing_pages/NewHomePage";
import PatientRightsPage from "../landing_pages/PatientRightsPage";
import PayorCaseManagementPage from "../landing_pages/PayorCaseManagementPage";
import PayorNetworkPage from "../landing_pages/PayorNetworkPage";
import ProvidersPage from "../landing_pages/ProvidersPage";
import SignatureCollectionPage from "../landing_pages/SignatureCollectionPage";
import TermsOfServicePage from "../landing_pages/TermsOfServicePage";

const NotFoundRoute: React.ComponentType = () =>
  React.createElement(ErrorPage, { variant: "not-found" });

export interface RouteConfig {
  path: string;
  component: React.ComponentType;
  exact?: boolean;
  requiresNav?: boolean;
}

export const routes: RouteConfig[] = [
  {
    path: "/",
    component: NewHomePage,
    exact: true,
  },
  {
    path: "/payor-network",
    component: PayorNetworkPage,
    exact: true,
  },
  {
    path: "/payor-case-management",
    component: PayorCaseManagementPage,
    exact: true,
  },
  {
    path: "/for-providers",
    component: ProvidersPage,
    exact: true,
  },
  {
    path: "/signature-collection",
    component: SignatureCollectionPage,
    exact: true,
  },
  {
    path: "/contact",
    component: ContactPage,
    exact: true,
  },
  {
    path: "/about",
    component: AboutPage,
    exact: true,
  },
  {
    path: "/life-at-verse",
    component: LifeAtVersePage,
    exact: true,
  },
  {
    path: "/password-login",
    component: LoginPage,
    exact: true,
    requiresNav: true,
  },
  {
    path: "/login",
    component: Login,
    exact: true,
    requiresNav: true,
  },
  {
    path: "/patient-rights-page",
    component: PatientRightsPage,
    exact: true,
  },
  {
    path: "/terms-of-service",
    component: TermsOfServicePage,
    exact: true,
  },
  {
    path: "*",
    component: NotFoundRoute,
  },
];

export default routes;
